import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GeneralJournalImportLineDTO  {
    _originalTypeClassName = "zERP.BO.GeneralJournalImportLineDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GeneralJournalImportLineDTO.translate = translateService;
}
this.Account = null;
this.Debit = null;
this.Credit = null;
this.Description = null;
this.GeneralJournalImportLineDTOKey = null;
this._key = this.GeneralJournalImportLineDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Account:any;
Debit:any;
Credit:any;
Description:any;
private _GeneralJournalImportLineDTOKey:any;
get GeneralJournalImportLineDTOKey(): any {
    return this._GeneralJournalImportLineDTOKey;
  }
set GeneralJournalImportLineDTOKey(value: any) {
    this._GeneralJournalImportLineDTOKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.GeneralJournalImportLineDTOKey == null || $this.GeneralJournalImportLineDTOKey == 0;
            }


}